import * as React from 'react';
import { NinetailedExperience } from './NinetailedExperience';
import { isComponentType } from '@avensia/excite';
import type { ItemType } from './types';

let useDisplayConditionsEvaluator: () => (displayConditions?: Excite.Contentful.ICFDisplayConditions) => boolean =
  () => () =>
    true;

export function registerDisplayConditionsEvaluator(
  useEvaluator: () => (displayConditions?: Excite.Contentful.ICFDisplayConditions) => boolean,
) {
  useDisplayConditionsEvaluator = useEvaluator;
}

export const ContentList = React.memo(<T extends { items: ItemType[] }>(props: T) => {
  const filterEntries = useDisplayConditionsEvaluator();

  return (
    <>
      {(props.items || [])
        .filter(
          i =>
            i && (isComponentType<Excite.Contentful.ConditionalPlaceholder>(i) || filterEntries(i.displayConditions)),
        )
        .map((item, i: number) => (
          <NinetailedExperience index={i} key={item.id + i} item={item} />
        ))}
    </>
  );
});
